import { EKeyCode } from '@/enums/e_key_code';
import { use_hint_shortcut } from '@/hooks/hints_shortcut/use_hint_shortcut';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { WATCHER_SHORTCUT__base } from '../../shortcuts/_watchers/WATCHER_SHORTCUT__base';

interface Props {
  page_type: string;
  key_codes: EKeyCode[];
}

export function WatcherShortcutPageNavigation({ page_type, key_codes }: Props) {
  const navigate = useNavigate();

  let is_page_opened = useMemo(() => location.pathname.includes(page_type), [location.pathname, page_type]);

  const { on_user_uses_shortcut } = use_hint_shortcut(EShortcutType.NAVIGATION_HOTKEYS_BETWEEN_PAGES);

  /*
   * EVENTS
   */
  function on_shortcut_pressed() {
    if (is_page_opened) return false; //page already opened
    if (key_codes.length == 0) return false; //no hotkey binded

    on_user_uses_shortcut();

    void navigate(page_type);

    return true;
  }

  if (is_page_opened) return null;

  return <WATCHER_SHORTCUT__base {...{ key_codes, on_shortcut_pressed }} />;
}
